<template>
  <div class="container">
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px;font-size: 2rem;">
      <label>สวัสดีคุณ {{ user.firstname }} {{ user.lastname }}
        ยินดีต้อนรับเข้าสู่การดำเนินกิจกรรม</label>
    </div>
    <div class="col-md-12 mb-3 mt-3" style="margin: 15px">
      <div class="d-flex align-items-start vh-100">

        <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical"
          style="min-width: 250px;">

          <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home"
            type="button" @click="showWalk = true">
            รายงานกิจกรรมการเดิน
          </button>

          <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile"
            type="button" @click="showHand = true">
            รายงานกิจกรรมบีบมือ
          </button>

          <button class="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages"
            type="button">
            บันทึกกิจกรรมการเดินสัปดาห์
          </button>

          <button class="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings"
            type="button">
            บันทึกกิจกรรมบีบมือสัปดาห์
          </button>
          <button class="nav-link" id="history-walk-tab" data-bs-toggle="pill" data-bs-target="#history-walk"
            type="button">
            ประวัติการเดินของคุณ
          </button>
          <button class="nav-link" id="history-hand-tab" data-bs-toggle="pill" data-bs-target="#history-hand"
            type="button">
            ประวัติการบีบมือของคุณ
          </button>
          <button class="btn btn-danger nav-link" @click="logout" type="button">
            ออกจากระบบ
          </button>
        </div>

        <div class="tab-content flex-grow-1 position-relative p-4" id="v-pills-tabContent">

          <div class="tab-pane fade show active h-200" id="v-pills-home">
            <div v-if="showWalk">
              <div id="walkReport">
                <h4>กิจกรรมการเดินรายสัปดาห์ของผู้ร่วมโครงการ</h4>

                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th>วันที่</th>
                      <th v-for="(n, index) in walk.finish_number_per_week" :key="index">
                        {{ index + 1 }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ผู้เข้าร่วมโครงการ</td>
                      <td v-for="r in walkDisplay" :key="r.id" :class="{
                        orangeCell: r.is_success === 1,
                        whiteCell: r.is_success === 0
                      }">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span v-if="checkWalk">ยินดีต้อนรับการดำเนินกิจกรรมการเดินวันที่ {{ user.round_walk }}
                ของสัปดาห์นี้ของคุณ</span>
              <button type="button" @click="StartWalk" v-if="checkWalk"
                class="btn btn-success btn-lg position-absolute bottom-3 end-0 m-4 mt-5">
                คลิกที่นี่เพื่อเริ่มดำเนินกิจกรรม
              </button>
            </div>
            <div v-else>
              <walk />
              <!-- <div class="card-body" style="text-align:center" @click="StartWalk" v-if="showTime">
                <button type="button" class="btn btn-secondary btn-lg" style="width:100%">
                  แสดงเวลาที่ใช้ในการดำเนินกิจกรรม <p>{{ formattedTime }} นาที</p>
                </button>

              </div>

              <div class="card-body" style="text-align:center" v-if="showCamera">
                <button type="button" v-if="!cameraOn" class="btn btn-success btn-lg" style="width:100%"
                  @click="startAndRecord">
                  เปิดกล้องมือถือเพื่อทำการบันทึกวิดีโอเวลา 10 วินาทีอัตโนมัติ
                </button>
                <video ref="preview" autoplay playsinline muted width="320"></video>
              </div>

              <div class="card-body" style="text-align:center" @click="startAndRecord" v-if="showFinish">
                <button type="button" @click="StartHand" class="btn btn-danger btn-lg" style="width:100%">
                  คลิกที่นี่เมื่อดำเนินกิจกรรมแล้วเสร็จ
                </button>
                <video ref="preview" autoplay playsinline muted width="320"></video>
              </div> -->
            </div>
          </div>

          <div class="tab-pane fade" id="v-pills-profile">
            <div v-if="showHand">
              <div id="walkReport">
                <h4>กิจกรรมการบีบมือรายสัปดาห์ของผู้ร่วมโครงการ</h4>

                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th>วันที่</th>
                      <th v-for="(n, index) in hand.finish_number_per_week" :key="index">
                        {{ index + 1 }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ผู้เข้าร่วมโครงการ</td>
                      <td v-for="(r, index) in handDisplay" :key="index" :class="{
                        orangeCell: r.isComplete === true,
                        whiteCell: r.isComplete === false
                      }">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <span>ยินดีต้อนรับการดำเนินกิจกรรมการบีบมือวันที่ {{ user.round_hand }} ของสัปดาห์นี้ของคุณ</span>
              <button type="button" @click="StartHand" v-if="checkHand"
                class="btn btn-success btn-lg position-absolute bottom-3 end-0 m-4 mt-5">
                คลิกที่นี่เพื่อเริ่มดำเนินกิจกรรม
              </button>
            </div>
            <div v-else>
              <hand />
            </div>
          </div>
          <div class="tab-pane fade" id="v-pills-messages">
            <h5 v-if="checkWalk">ยินดีต้อนรับการดำเนินกิจกรรมการเดินวันที่ {{ user.round_walk }} ของสัปดาห์นี้ของคุณ
            </h5>
            <walk />
            <!-- <div class="card-body" style="text-align:center" @click="StartHand" v-if="showTime">
              <button type="button" class="btn btn-secondary btn-lg" style="width:100%">
                แสดงเวลาที่ใช้ในการดำเนินกิจกรรม <p>{{ formattedTime }} นาที</p>
              </button>

            </div>

            <div class="card-body" style="text-align:center" v-if="showCamera">
              <button type="button" v-if="!cameraOn" class="btn btn-success btn-lg" style="width:100%"
                @click="startAndRecord">
                เปิดกล้องมือถือเพื่อทำการบันทึกวิดีโอเวลา 10 วินาทีอัตโนมัติ
              </button>
              <video ref="preview" autoplay playsinline muted width="320"></video>
            </div>

            <div class="card-body" style="text-align:center" @click="startAndRecord" v-if="showFinish">
              <button type="button" @click="StartHand" class="btn btn-danger btn-lg" style="width:100%">
                คลิกที่นี่เมื่อดำเนินกิจกรรมแล้วเสร็จ
              </button>
              <video ref="preview" autoplay playsinline muted width="320"></video>
            </div> -->
          </div>
          <div class="tab-pane fade" id="v-pills-settings">
            <hand />
          </div>
          <div class="tab-pane fade" id="history-walk">
            <ParticipantHistory v-if="participant_id != null" :id="Number(participant_id)" :type="1" />
          </div>
          <div class="tab-pane fade" id="history-hand">
            <ParticipantHistory v-if="participant_id != null" :id="Number(participant_id)" :type="2" />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>

import ParticipantService from "../services/ParticipantService";
import ParticipantsActivitiesService from "../services/ParticipantsActivitiesService";
import ActivitiesService from "../services/ActivitiesService";
import LinkService from "../services/LinkService";
import walk from "./walk.vue";
import hand from "./hand.vue";
import ParticipantHistory from './ParticipantHistory.vue'

import axios from "axios";

export default {
  name: "Nav",
  components: {
    walk,
    hand,
    ParticipantHistory
  },
  props: {
    msg: String,
  },
  data() {
    return {
      data: {},
      user: {},
      busy: false,
      cameraOn: false,
      recording: false,
      videoUrl: null,
      videoUrlHand: null,
      stream: null,
      recorder: null,
      chunks: [],
      stopTimerId: null,
      showWalk: true,
      showHand: true,
      seconds: 0,
      timer: null,
      showTime: false,
      showFinish: false,
      showCamera: true,
      showPreview: false,
      walk_per_week: 0,
      hand_per_week: 0,
      walk: {},
      hand: {},
      startHandShow: true,
      stopHandShow: true,
      ShowOpenCameraHand: false,
      totalSeconds: 120,
      isRunning: false,
      id: 0,
      checkWalk: true,
      checkHand: true,
      selectedParticipantId: null,
      participant_id: null
    };
  },
  mounted() {
    // const key = "device_id";
    this.id = this.$route.params.id
    this.participant_id = this.$route.params.participant_id
    console.log(this.participant_id,'home');
    
    if (this.id) {
      localStorage.removeItem("device_id");
      localStorage.removeItem("participant_id");
      localStorage.setItem("device_id", this.id);
      localStorage.setItem("participant_id", this.participant_id);
      this.getActivity(this.id)
      // console.log(this.id);
      let participants_activity_id = localStorage.getItem("participants_activity_id");
      // console.log(participants_activity_id);

      if (participants_activity_id) {
        this.showFinish = true
        this.showTime = true
        this.showCamera = false
      }
      this.getWalk();
      this.getHand();
    } else {
      this.$router.push("/register");
    }


  },
  methods: {
    logout() {
      // localStorage.removeItem("device_id");
      localStorage.removeItem("participants_activity_id");
      localStorage.removeItem("participants_activity_hand_id");
      localStorage.removeItem("device_id");
      localStorage.removeItem("participant_id");
      this.$router.push("/firstpage");
    },
    shouldNotify(activity, records) {
      // console.log(activity, 'activity');
      // console.log(records, 'records');


      const daysOfWeek = JSON.parse(activity.days_of_week);

      const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
      const today = new Date();
      const todayIndex = today.getDay();
      const todayKey = dayMap[todayIndex];
      // console.log(todayKey,'todayKey');


      if (!daysOfWeek[todayKey]) {
        return false;
      }

      const recordList = Array.isArray(records) ? records : [records];

      const todayRecord = recordList.find(r => {
        const recordDate = r.finished_at || r.started_at;
        if (!recordDate) return false;

        const d = new Date(recordDate);
        return (
          d.getFullYear() === today.getFullYear() &&
          d.getMonth() === today.getMonth() &&
          d.getDate() === today.getDate()
        );
      });
      // console.log(todayRecord,'todayRecord');

      // วันนี้มีและ finished แล้ว => false ทันที
      if (todayRecord && todayRecord.finished_at) {
        return false;
      }

      // วันนี้ยังไม่มี หรือยังไม่เสร็จ => true
      return true;
    },
    getActivity(id) {
      console.log(id, 'id');
      
      ParticipantService.get_participant(id).then(
        (response) => {
          // console.log('get_participant', response);

          if (response.status == 200) {
            this.user = response.data;
            this.$set(this, 'selectedParticipantId', this.user.id)
            // console.log(this.selectedParticipantId, 'selectedParticipantId');

            // this.selectedParticipantId = this.user.id
            ParticipantService.get_participant_by_imei(this.user.id).then(
              (response) => {
                // console.log('get_participant_by_imei', response);
                if (response.status == 200) {
                  this.$set(this.user, 'walk', response.data.filter(i => i.activity_id === 1))
                  this.$set(this.user, 'hand', response.data.filter(i => i.activity_id === 2))
                  this.$set(this.user, 'round_walk', response.data.filter(i => i.activity_id === 1).length + 1)
                  if (this.user.hand[this.user.hand.length - 1] == null) {
                    this.$set(this.user, 'round_hand', 1)
                  } else {
                    this.$set(this.user, 'round_hand', this.user.hand[this.user.hand.length - 1].round)
                  }
                  //                   console.log(this.user.walk, 'user');
                  // console.log(this.walk,'walk data');
                  if (this.shouldNotify(this.walk, this.user.walk)) {
                    //  console.log(true);
                    this.checkWalk = true
                  } else {
                    // console.log(false);
                    this.checkWalk = false
                  }
                  // console.log(this.checkWalk,'home page');
                  if (this.shouldNotify(this.hand, this.user.hand)) {
                    //  console.log(true);
                    this.checkHand = true
                  } else {
                    // console.log(false);
                    this.checkHand = false
                  }

                  // console.log(this.user.round_walk);
                  // console.log(this.user.round_hand);
                  // console.log(this.user.hand);
                  // console.log(this.user.hand[this.user.hand.length-1]);
                  // console.log(JSON.parse(this.hand.style));
                  // console.log(JSON.parse(this.hand.style).length);

                  // console.log(this.user.hand, 'hand');
                  // console.log(localStorage.getItem("participants_activity_hand_id"));

                  if (JSON.parse(this.hand.style).length == this.user.hand.length && this.user.hand[this.user.hand.length - 1].finished_at != null) {
                    this.startHandShow = true
                    this.stopHandShow = true
                    this.ShowOpenCameraHand = true

                  } else {
                    let participants_activity_hand_id = localStorage.getItem("participants_activity_hand_id");
                    // console.log(participants_activity_hand_id, 'test');
                    if (participants_activity_hand_id == null) {
                      this.startHandShow = true
                      this.stopHandShow = true
                      this.ShowOpenCameraHand = false
                    } else {
                      // localStorage.setItem("participants_activity_hand_id", this.user.hand[this.user.hand.length - 1].id)
                      // let participants_activity_hand_id = localStorage.getItem("participants_activity_hand_id");
                      // console.log(participants_activity_hand_id, 'participants_activity_hand_id');
                      if (this.user.hand[this.user.hand.length - 1]) {
                        if (this.user.hand[this.user.hand.length - 1].started_at == null) {
                          this.startHandShow = false
                          this.stopHandShow = true
                          this.ShowOpenCameraHand = true
                        } else {
                          if (this.user.hand[this.user.hand.length - 1].finished_at == null) {
                            localStorage.setItem("participants_activity_hand_id", this.user.hand[this.user.hand.length - 1].id)
                            this.startHandShow = true
                            this.stopHandShow = false
                            this.ShowOpenCameraHand = true

                          }
                        }
                      }
                    }
                  }
                }
              },
              (error) => {
                console.log(error);
              }
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );

    },
    formatThaiDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('th-TH', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    getWalk() {
      ActivitiesService.getactivity(1).then((res) => {
        this.walk = res.data
        this.walk_per_week = res.data.finish_number_per_week;
        // console.log(this.walk_per_week);
      });
    },
    getHand() {
      ActivitiesService.getactivity(2).then((res) => {
        this.hand = res.data
        this.hand_per_week = res.data.finish_number_per_week;
        // console.log(this.hand_per_week);
      });
    },
    StartWalk() {
      this.showWalk = false;
    },
    StartHand() {
      this.showHand = false;
    },
    async startAndRecordHand() {
      if (this.busy) return;
      this.busy = true;

      try {
        if (this.videoUrlHand) {
          URL.revokeObjectURL(this.videoUrlHand);
          this.videoUrlHand = null;
        }

        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: true,
        });

        this.$refs.preview.srcObject = this.stream;
        this.cameraOn = true;

        this.startRecordingNowHand();
        let record_second_walk = parseInt(this.walk.records * 1100)
        // console.log(record_second_walk, 'record_second_walk');

        this.stopTimerId = window.setTimeout(() => {
          this.stopRecording();
          // this.stopAll();
        }, record_second_walk); //11000
      } catch (err) {
        console.error(err);
        alert("เปิดกล้อง/อัดวิดีโอไม่ได้ กรุณาอนุญาตกล้องและไมค์");
        // await this.stopAll();
      } finally {
        this.busy = false;
      }
    },
    async startAndRecord() {
      if (this.busy) return;
      this.busy = true;

      try {
        if (this.videoUrl) {
          URL.revokeObjectURL(this.videoUrl);
          this.videoUrl = null;
        }

        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "user" },
          audio: true,
        });

        this.$refs.preview.srcObject = this.stream;
        this.cameraOn = true;

        this.startRecordingNow();
        let record_second_walk = parseInt(this.walk.records * 1100)
        // console.log(record_second_walk, 'record_second_walk');

        this.stopTimerId = window.setTimeout(() => {
          this.stopRecording();
          this.stopAll();
        }, record_second_walk); //11000
      } catch (err) {
        console.error(err);
        alert("เปิดกล้อง/อัดวิดีโอไม่ได้ กรุณาอนุญาตกล้องและไมค์");
        // await this.stopAll();
      } finally {
        this.busy = false;
      }
    },
    startHand() {
      let participants_activity_hand_id = localStorage.getItem('participants_activity_hand_id');
      if (participants_activity_hand_id != null) {
        ParticipantsActivitiesService.updateparticipants_activitie(participants_activity_hand_id, {
          started_at: new Date(),
        }).then((res) => {
          // console.log(res.data);
          localStorage.setItem("participants_activity_hand_id", res.data.id);
          this.startHandShow = true
          this.stopHandShow = false
          this.ShowOpenCameraHand = true
          this.startCountdown()
        });
      }
    },
    finishHand() {
      let participants_activity_hand_id = localStorage.getItem('participants_activity_hand_id');
      if (participants_activity_hand_id != null) {
        ParticipantsActivitiesService.updateparticipants_activitie(participants_activity_hand_id, {
          finished_at: new Date(),
        }).then(() => {
          // console.log(res.data);
          this.getActivity(this.id)
          if (JSON.parse(this.hand.style).length == this.user.hand.length - 1) {
            localStorage.removeItem("participants_activity_hand_id");
          }
          this.startHandShow = false
          this.stopHandShow = true
          this.ShowOpenCameraHand = true
          alert("บันทึกกิจกรรมการบีบมือสำเร็จ");
        });
      }
    },
    insertupdateParticipantsActivities(id, fileName, type_walk) {
      if (id != 0) {
        ParticipantsActivitiesService.updateparticipants_activitie(id, {
          end_record_path: `/uploads/walk/${type_walk}_${fileName}`,
          finished_at: new Date(),
        }).then(() => {
          // console.log(res.data);
          localStorage.removeItem("participants_activity_id");
          this.showFinish = false
          this.showTime = false
          this.showCamera = true
          this.showPreview = false
          this.getActivity(this.id)
          alert("บันทึกภาพวิดีโอการสิ้นสุดกิจกรรมการเดินสำเร็จ");
        });
      } else {
        ParticipantsActivitiesService.create_participants_activitie({
          participant_id: this.user.id,
          activity_id: 1,
          monitoring_number_id: this.user.monitoring_number_id,
          round: this.user.round_walk,
          set_of_activities: 1,
          start_record_path: `/uploads/walk/${type_walk}_${fileName}`,
        }).then((res) => {
          // console.log(res.data);
          localStorage.setItem("participants_activity_id", res.data.id);
          this.showFinish = true
          this.showTime = true
          this.showCamera = false
          alert("บันทึกภาพวิดีโอการเริ่มต้นกิจกรรมการเดินสำเร็จ เริ่มกิจกรรมการเดินได้เลยค่ะ");
          this.timer = setInterval(() => {
            this.seconds++
          }, 1000)
        });
      }
    },
    insertupdateParticipantsActivitiesHand(id, fileName, type_walk) {
      if (id == 0) {
        ParticipantsActivitiesService.create_participants_activitie({
          participant_id: this.user.id,
          activity_id: 2,
          monitoring_number_id: this.user.monitoring_number_id,
          round: this.user.round_hand,
          set_of_activities: this.user.hand.length + 1,
          start_record_path: `/uploads/hand/${type_walk}_${fileName}`,
          // started_at: new Date(),
        }).then((res) => {
          // console.log(res.data);
          localStorage.setItem("participants_activity_hand_id", res.data.id);
          this.startHandShow = false
          this.stopHandShow = true
          this.ShowOpenCameraHand = true
          alert("บันทึกภาพวิดีโอการเริ่มต้นกิจกรรมบีบมือสำเร็จ เริ่มกิจกรรมการบีบมือได้เลยค่ะ");
          this.startCountdown()
        });
      } else {
        ParticipantsActivitiesService.updateparticipants_activitie(id, {
          end_record_path: `/uploads/hand/${type_walk}_${fileName}`,
          finished_at: new Date(),
        }).then(() => {
          // console.log(res.data);
          localStorage.removeItem("participants_activity_hand_id");
          this.startHandShow = true
          this.stopHandShow = true
          this.ShowOpenCameraHand = true
          alert("บันทึกภาพวิดีโอการเริ่มต้นกิจกรรมบีบมือสำเร็จ");
        });
      }
    },
    startRecordingNowHand() {
      this.showPreview = true
      let participants_activity_id = localStorage.getItem('participants_activity_hand_id');

      if (!this.stream) return;

      this.chunks = [];

      const preferredMime = "video/webm;codecs=vp8,opus";
      let options = {};
      if (window.MediaRecorder && MediaRecorder.isTypeSupported(preferredMime)) {
        options = { mimeType: preferredMime };
      }

      this.recorder = new MediaRecorder(this.stream, options);

      this.recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) this.chunks.push(e.data);
      };

      this.recorder.onstop = async () => {
        const blob = new Blob(this.chunks, {
          type: this.recorder.mimeType || "video/webm",
        });

        this.videoUrl = URL.createObjectURL(blob);

        const fileName = `video_hand_${this.user.id}.webm`;

        const formData = new FormData();
        formData.append("file", blob, fileName);
        formData.append("name", fileName);
        var type_hand = 'start'
        try {
          if (participants_activity_id) {
            type_hand = 'finish'
          } else {
            participants_activity_id = 0
          }
          const res = await axios.post(
            LinkService.getLink() + `/uploadvideo?name=hand/${type_hand}_${fileName}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("Upload success:", res.data);
          this.insertupdateParticipantsActivitiesHand(participants_activity_id, fileName, type_hand);

        } catch (err) {
          console.error("Upload error:", err);
        }
      };

      this.recorder.start();
      this.recording = true;
    },
    startRecordingNow() {
      this.showPreview = true
      let participants_activity_id = localStorage.getItem('participants_activity_id');

      if (!this.stream) return;

      this.chunks = [];

      const preferredMime = "video/webm;codecs=vp8,opus";
      let options = {};
      if (window.MediaRecorder && MediaRecorder.isTypeSupported(preferredMime)) {
        options = { mimeType: preferredMime };
      }

      this.recorder = new MediaRecorder(this.stream, options);

      this.recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) this.chunks.push(e.data);
      };

      this.recorder.onstop = async () => {
        const blob = new Blob(this.chunks, {
          type: this.recorder.mimeType || "video/webm",
        });

        this.videoUrl = URL.createObjectURL(blob);

        const fileName = `video_walk_${this.user.id}.webm`;

        const formData = new FormData();
        formData.append("file", blob, fileName);
        formData.append("name", fileName);
        var type_walk = 'start'
        try {
          if (participants_activity_id) {
            type_walk = 'finish'
          } else {
            participants_activity_id = 0
          }
          const res = await axios.post(
            LinkService.getLink() + `/uploadvideo?name=walk/${type_walk}_${fileName}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          console.log("Upload success:", res.data);
          this.insertupdateParticipantsActivities(participants_activity_id, fileName, type_walk);

        } catch (err) {
          console.error("Upload error:", err);
        }
      };

      // this.recorder.onstop = () => {
      //   const blob = new Blob(this.chunks, {
      //     type: this.recorder.mimeType || "video/webm",
      //   });
      //   this.videoUrl = URL.createObjectURL(blob);
      //   console.log(this.videoUrl,'videoUrl');

      // };

      this.recorder.start();
      this.recording = true;
    },
    stopRecording() {
      if (this.stopTimerId) {
        clearTimeout(this.stopTimerId);
        this.stopTimerId = null;
      }

      if (this.recorder && this.recorder.state !== "inactive") {
        this.recorder.stop();
      }
      this.recording = false;
    },

    async stopAll() {
      if (this.recording) this.stopRecording();

      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
        this.stream = null;
      }

      if (this.$refs.preview && this.$refs.preview.srcObject) {
        this.$refs.preview.srcObject = null;
      }
      // console.log(this.videoUrl);

      this.cameraOn = false;
    },
    beforeDestroy() {
      this.stopAll();
      if (this.videoUrl) URL.revokeObjectURL(this.videoUrl);
      clearInterval(this.timer)
    },
    showTable(id, btn) {

      document.querySelectorAll('.table-content').forEach(el => {
        el.classList.add('hidden');
      });

      document.getElementById(id).classList.remove('hidden');

      document.querySelectorAll('.menu-btn').forEach(b => {
        b.classList.remove('active');
      });

      btn.classList.add('active');
    },
    startCountdown() {
      if (this.isRunning) return;

      this.isRunning = true;
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.isRunning = false;
          alert('หมดเวลา');
        }
      }, 1000);
    },
  },
  computed: {
    handDisplay() {
      const hand = this.user.hand || []
      const totalDays = 3 // ต้องการแสดงทั้งหมดกี่วัน

      // group ตามวัน
      const grouped = {}

      hand.forEach(item => {
        // ตัดเวลาออก เหลือเฉพาะวัน
        const dateKey = item.activity_date?.slice(0, 10)

        if (!dateKey) return

        if (!grouped[dateKey]) {
          grouped[dateKey] = []
        }

        grouped[dateKey].push(item)
      })

      // เรียงวันจากน้อยไปมาก แล้วตรวจแต่ละวัน
      const result = Object.keys(grouped)
        .sort((a, b) => new Date(a) - new Date(b))
        .map(date => {
          const items = grouped[date]

          const requiredSets = [1, 2, 3, 4]

          const isComplete = requiredSets.every(setNo => {
            const found = items.find(x => x.set_of_activities === setNo)
            return found && found.is_success === 1
          })

          return {
            date,
            items,
            isComplete
          }
        })

      // เติมช่องว่างให้ครบ totalDays
      while (result.length < totalDays) {
        result.push({
          date: null,
          items: [],
          isComplete: "",
          empty: true
        })
      }

      return result
    },
    walkDisplay() {
      const walks = this.user.walk || []
      const total = 5

      const result = [...walks]

      while (result.length < total) {
        result.push({ is_success: null, empty: true })
      }

      return result
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    minutes() {
      return Math.floor(this.seconds / 60)
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    formattedTime() {
      const m = Math.floor(this.seconds / 60)
      const s = this.seconds % 60
      return m + ":" + String(s).padStart(2, "0")
    },
    timeLeft() {
      const minutes = Math.floor(this.totalSeconds / 60);
      const seconds = this.totalSeconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  },
}
</script>

<style scoped>
.orangeCell {
  background: orange;
}

.whiteCell {
  background-color: black;
  border: 1px solid #ccc;
}
</style>
